import Cookies from "js-cookie";
import posthog from "posthog-js";

export const posthogCapture = (eventName, data) => {
  const userId = Cookies.get("userToken");
  const customData = { user_id: userId, ...data };
  posthog.capture(eventName, customData);
};
